const data = {
  'marketplace.seller.form.sellerType': 'Seller Type',
  'marketplace.seller.form.sellerType.placeholder': 'Select Seller Type',
  'marketplace.seller.form.fulfilmentType': 'Fulfilment Type',
}

export default data
